import APIContext from 'contexts/base/APIContext'

export default class GxpsContext extends APIContext{
  static contextName = 'gxps'
}
